// Plugins
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';

// Modules
import customProperties from './modules/custom-properties';
import navigation from './modules/navigation';
import sprites from './modules/sprites';
import pageAnchors from './modules/page-anchors';
import scrollIndicator from './modules/scroll-indicator';
import animations from './modules/animations';
import video from './modules/video';
import collapsibleQuestions from './modules/collapsible-questions';
import slider from './modules/slider';
import labeledSlider from './modules/labeled-slider';
import scrollingSections from './modules/scrolling-sections';
import scrollvideo from './modules/video-scroll';

// Init
lazySizes.init();
customProperties();
navigation();
sprites();
pageAnchors();
scrollIndicator();
animations();
video();
collapsibleQuestions();
slider();
labeledSlider();
scrollingSections();
scrollvideo();

document.body.classList.add('js');